import { Navigate } from "react-router";
import { Box, CircularProgress } from "@mui/material";
import { useNavSignals } from "src/hooks/useNavSignals";
import { homePathFor } from "src/utils/nav/navState";

/**
 * Role guard for the operator-only routes (/tarjouspyynnot, /hallinta, /tuki,
 * /liity). Sits INSIDE RequireAuth: authentication is that guard's job, this one
 * only answers "is this session a pump provider".
 *
 * It exists because an identity swap — impersonate start/stop, company switch —
 * changes who the session is without re-resolving the current route. A staffer
 * sitting on the operator inbox who started impersonating a customer stayed on
 * /tarjouspyynnot and got the "tarkoitettu pumppausyrityksille" 403 notice
 * instead of the customer's own /valut. Non-operators now land on their own home
 * (homePathFor: /valut when they have orders, else the Landing page).
 *
 * Waiting on `loading` is load-bearing: redirecting mid-probe would route on a
 * role derived from the PREVIOUS identity, which is the very bug this prevents.
 */
export default function RequireOperator({ children }) {
    const { role, loading, hasActiveOrders, operatorNeedsActivation } = useNavSignals();

    if (loading) {
        return (
            <Box sx={{ display: "flex", justifyContent: "center", py: 8 }}>
                <CircularProgress />
            </Box>
        );
    }

    if (role !== "operator") {
        return <Navigate to={homePathFor({ role, hasActiveOrders, operatorNeedsActivation })} replace />;
    }

    return children;
}
